import React, { Fragment } from "react";
import { connect } from "react-redux";
import Axios from "axios";
import { API_ROOT } from "../components/utils/api-config";
import ShowFulfillment from "../components/ShowFulfillment";
import EditFulfillment from "../components/EditFulfillment";
import { requestFulfillment } from "../actions/fulfillmentAction";
import { getTasksInfo, resetTasksInfo } from "../actions/routeAction";
import { resetDelivery } from "../actions/deliveryAction";
import DeliveryContainer from "./DeliveryContainer";
import MessagesContainer from "./MessagesContainer";
import RouteTaskContainer from "./RouteTaskContainer";
import Spinner from "../components/layout/Spinner";
import Tab from "react-bootstrap/Tab";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Table from "react-bootstrap/Table";
import Accordion from "react-bootstrap/Accordion";
import { Card, Button } from "react-bootstrap";
import moment from "moment";

class FulfillmentContainer extends React.Component {
  state = {
    activeKey: "show",
    display: "show",
    accordion: null,
    audits: false,
    messages: false,
    data: null,
  };
  componentDidMount() {
    this.props.requestFulfillment(this.props.match.params.id);
  }
  show = () => {
    this.setState({ activeKey: "show" });
  };
  edit = () => {
    this.setState({ activeKey: "edit" });
  };
  showD = () => {
    this.setState({ display: "show" });
  };
  editD = () => {
    this.setState({ display: "edit" });
  };
  showDel = (id) => {
    this.state.resetDelivery;
    this.setState({ accordion: id });
  };
  showMessages = () => {
    this.setState({ messages: true, audits: false });
  };
  showAudits = () => {
    this.setState({ audits: true });
    let token = "Bearer " + localStorage.getItem("token");
    const auth = {
      headers: {
        Authorization: token,
      },
    };
    Axios.get(
      `${API_ROOT}/orders/audits?id=${this.props.match.params.id}/`,
      auth
    )
      .then((response) => this.setState({ data: response.data }))
      .catch((error) => {
        console.log(error);
      });
  };
  // renderInner(props) {
  //   let { display } = this.state;

  //   if (display === "show") {
  //     return <ShowDelivery key={props.id} delivery={props} edit={this.editD} />;
  //   } else if (display === "edit") {
  //     return <EditDelivery key={props.id} delivery={props} show={this.showD} />;
  //   }
  // }
  render() {
    const { loading, fulfillment } = this.props;
    return (
      <Fragment>
        {loading ? (
          <Spinner />
        ) : (
          <Tab.Container
            mountOnEnter
            unmountOnExit
            id="left-tabs-example"
            activeKey={this.state.activeKey}
          >
            {/* <Col sm={2} className="pt-5"> */}
            {/* <Nav variant="tabs" className="flex-column">
                  <Nav.Item>
                  <Nav.Link
                  eventKey="show"
                  onSelect={() => this.setState({ activeKey: "show" })}
                  >
                  Show Fulfillment
                  </Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                  <Nav.Link
                  eventKey="edit"
                  onSelect={() => this.setState({ activeKey: "edit" })}
                  >
                  Edit Fulfillment
                  </Nav.Link>
                  </Nav.Item>
                  </Nav>
                </Col> */}
            {/* <Col sm={10}> */}
            <div className="container-fluid pt-5">
              <Tab.Content>
                <Tab.Pane eventKey="show">
                  <Row>
                    <Col xs={12} md={6}>
                      {/* <Button variant="dark">Order</Button> */}
                      <ShowFulfillment
                        fulfillment={fulfillment}
                        edit={this.edit}
                      />
                    </Col>
                    <Col xs={12} md={6}>
                      {fulfillment.deliveries && (
                        <Button
                          onClick={() =>
                            this.setState({ audits: false, messages: false })
                          }
                          variant="info"
                        >
                          Order Deliveries
                        </Button>
                      )}{" "}
                      <Button
                        onClick={() => this.showAudits()}
                        variant="primary"
                      >
                        Order Audits
                      </Button>{" "}
                      <Button
                        onClick={() => this.showMessages()}
                        variant="danger"
                      >
                        Twilio Messages
                      </Button>
                      {this.state.audits && this.state.data ? (
                        <Table striped bordered hover responsive>
                          <thead>
                            <tr className="table-light">
                              <th>
                                Id <br></br>
                                <span className="badge badge-pill badge-warning">
                                  User Id
                                </span>
                              </th>
                              <th>Created At </th>
                              <th>Audited Changes</th>
                            </tr>
                          </thead>
                          <tbody>
                            {this.state.data.audits.map((item) => {
                              return (
                                <tr key={item.id} className="table-primary">
                                  <td>
                                    {item.action == "create" && (
                                      <span className="badge badge-pill badge-primary">
                                        {item.auditable_id}
                                      </span>
                                    )}
                                    <br></br>
                                    <span className="badge badge-pill badge-warning">
                                      {item.user_id}
                                    </span>
                                  </td>
                                  <td>
                                    {moment(item.created_at).format(
                                      "MMM DD, h:mma"
                                    )}
                                  </td>
                                  <td>
                                    {JSON.stringify(item.audited_changes)}
                                  </td>
                                </tr>
                              );
                            })}
                            {this.state.data.associated_audits.map((item) => {
                              return (
                                <tr key={item.id} className="table-info">
                                  <td>
                                    {item.action == "create" && (
                                      <span className="badge badge-pill badge-info">
                                        {item.auditable_id}
                                      </span>
                                    )}
                                    <br></br>
                                    <span className="badge badge-pill badge-warning">
                                      {item.user_id}
                                    </span>
                                  </td>
                                  <td>
                                    {moment(item.created_at).format(
                                      "MMM DD, h:mma"
                                    )}
                                  </td>
                                  <td>
                                    {JSON.stringify(item.audited_changes)}
                                  </td>
                                </tr>
                              );
                            })}
                          </tbody>
                        </Table>
                      ) : this.state.messages ? (
                        <MessagesContainer id={fulfillment.id} />
                      ) : (
                        <Accordion>
                          {fulfillment.deliveries &&
                            fulfillment.deliveries.map((delivery, i) => {
                              const id = delivery.id;
                              return (
                                <Card key={id}>
                                  <Accordion.Toggle
                                    as={Button}
                                    variant="outline-info"
                                    eventKey={id}
                                    onClick={() => this.showDel(id)}
                                  >
                                    {delivery.id} -{" "}
                                    {delivery.date
                                      ? delivery.date
                                      : "Not scheduled"}{" "}
                                    {delivery.delivery_window}
                                  </Accordion.Toggle>
                                  <Accordion.Collapse eventKey={id}>
                                    <Fragment>
                                      {this.state.accordion == id && (
                                        <Fragment>
                                          <DeliveryContainer key={id} id={id} />
                                          {delivery.route_id && (
                                            <RouteTaskContainer
                                              id={delivery.route_id}
                                            />
                                          )}
                                        </Fragment>
                                      )}
                                    </Fragment>
                                  </Accordion.Collapse>
                                </Card>
                              );
                            })}
                        </Accordion>
                      )}
                    </Col>
                  </Row>
                  {/* return{" "}
                    <ShowDelivery delivery={delivery} />; //{" "}
                    this.renderInner(delivery) */}
                </Tab.Pane>
                <Tab.Pane eventKey="edit">
                  <EditFulfillment
                    fulfillment={fulfillment}
                    updateFulfillment={this.props.requestFulfillment}
                    show={this.show}
                  />
                </Tab.Pane>
              </Tab.Content>
            </div>
            {/* </Col> */}
          </Tab.Container>
        )}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => ({
  fulfillment: state.requestFulfillment.fulfillment,
  loading: state.requestFulfillment.loading,
});
const mapDispatchToProps = (dispatch) => ({
  requestFulfillment: (fulfillmentId) =>
    dispatch(requestFulfillment(fulfillmentId)),
  getTasksInfo: (getTasks) => dispatch(getTasksInfo(getTasks)),
  resetDelivery: () => dispatch(resetDelivery()),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FulfillmentContainer);
